export default defineNuxtPlugin(() => {
  return {
    provide: {
      formatCurrency: (value, format) => {
        if (value === 0) {
          // 0 has to be handle explicitly because it's a falsy condition and cannot be divided by 100
          return (0).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).split('.')[0]
        } else if (value) {
          const currency = format === 'dollars' ? value : value / 100
          const formattedCurrency = currency.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

          return format === 'dollars' ? formattedCurrency.split('.')[0] : formattedCurrency
        }
      },
    },
  }
})
